import $xhr from './xhr.js';

export default function Flashii(baseUrl) {
    if(typeof baseUrl !== 'string')
        throw new Error('baseUrl must be a string');
    if(baseUrl.indexOf('//') === 0)
        baseUrl = window.location.protocol + baseUrl;

    const sortArray = typeof Array.prototype.toSorted === 'function'
        ? array => array.toSorted()
        : array => {
            array = array.slice();
            array.sort();
            return array;
        };

    const convertFields = fields => {
        if(fields === true)
            return '*';

        if(Array.isArray(fields))
            return sortArray(fields).join(',');

        if(typeof fields === 'string')
            return fields;

        return null;
    };

    const createUrl = (path, fields=null) => {
        const url = baseUrl + path;
        const params = {};

        if(fields)
            params['fields'] = convertFields(fields);

        return {
            setParam(name, value) {
                params[name] = value;
            },
            deleteParam(name) {
                delete params[name];
            },
            toString() {
                let str = url;

                const queryParts = [];
                for(const name in params)
                    if(params.hasOwnProperty(name))
                        queryParts.push(encodeURIComponent(name) + '=' + encodeURIComponent(params[name]));
                if(queryParts.length > 0)
                    str += (str.indexOf('?') < 0 ? '?' : '&') + queryParts.join('&');

                return str;
            },
        };
    };

    const send = async ({
        method,
        path,
        fresh=false,
        params=null,
        fields=null,
        body=null,
        headers=null,
        type='json',
        authed=false,
    }) => {
        const url = createUrl(path, fields);
        if(params)
            for(const name in params) {
                if(name === 'fields' || params[name] === null || params[name] === undefined)
                    continue;

                url.setParam(name, params[name]);
            }

        headers ??= {};
        if(fresh) headers['Cache-Control'] = 'no-cache';

        const options = { type, headers, authed };

        return await $xhr.send(method, url, options, body);
    };

    const fii = {};

    fii.v1 = {};

    fii.v1.chat = {};
    fii.v1.chat.login = function({ redirect=null, assign=true }) {
        return new Promise(resolve => {
            redirect ??= `${location.protocol}//${location.host}`;
            if(typeof redirect !== 'string')
                throw new Error('redirect must a string.');

            const url = createUrl('/v1/chat/login');
            url.setParam('redirect', redirect);

            // intentionally does not call resolve
            if(assign)
                location.assign(url);
            else
                resolve(url);
        });
    };
    fii.v1.chat.servers = {};
    fii.v1.chat.servers.recommended = async function({ proto, secure=null, fields=null, fresh=false }) {
        if(typeof proto !== 'string')
            throw new Error('proto must be a string');

        const params = { proto };
        if(secure !== null)
            params['secure'] = secure ? '1' : '0';

        const { status, body } = await send({ method: 'GET', path: '/v1/chat/servers/recommended', fields, fresh, params });

        if(status === 400)
            throw new Error('An argument contains an unsupported value.');
        if(status === 404)
            throw new Error('Was unable to determine a server based on the requested parameters.');
        if(status > 299)
            throw new Error(`Failed to fetch recommended chat server with error code ${status}.`);

        return body;
    };

    fii.v1.colours = {};
    fii.v1.colours.presets = async function({ fields=null, fresh=false }) {
        const { status, body } = await send({ method: 'GET', path: '/v1/colours/presets', fields, fresh });

        if(status === 400)
            throw new Error('Fields argument contains unsupported value.');
        if(status > 299)
            throw new Error(`Failed to fetch colour presets with error code ${status}.`);

        return body;
    };

    fii.v1.emotes = async function({ fields=null, fresh=false }) {
        const { status, body } = await send({ method: 'GET', path: '/v1/emotes', fields, fresh });

        if(status === 400)
            throw new Error('Fields argument contains unsupported value.');
        if(status > 299)
            throw new Error(`Failed to fetch emoticons with error code ${status}.`);

        return body;
    };

    return fii;
};
